import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const RequestCreatePropertyPanelModule = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "forge-request-create-property-panel" */ './request-create-property-panel')
    ),
    LoadingSkeleton: () => null,
});
